import { View, } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const MdInformationOnline = ({ navigation, route }) => {
    const {
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        claimExemptionsLastYear,
        claimExemptionsThisYear
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()
    const { postMdOnline, loading } = useFormsStore()



    const handlesubmit = async (signatureDataURL: any) => {

        const data = {
            entityId: personalstore.personalData?.entityId,
            essUserKey: intializestore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            county: values?.residence,
            filingStatus: values?.filingstatus,
            additionalWithholdings: Number(values?.additionalwithholding),
            year: values?.year ? Number(values?.year) : null,
            domiciledState: values?.listOfStates != null ? values?.listOfStates.toString() : null,
            stateWithholdingExemption: values?.placeofabodeinMaryland,
            claimExemptionsLastYear: claimExemptionsLastYear,
            claimExemptionsThisYear: claimExemptionsThisYear,
            localTaxExemption: values?.exemptfrommarylandlocaltax,
            nonMarylandLocalTaxExemption: values?.incometax,
            totalExemptions: Number(values?.maximumNoOfExemptions),
            sign: signatureDataURL,
            stateOfLegalResident: values?.stateOfLegalResident,
            isMarylandWithholdingExempt: values?.isMarylandWithholdingExempt
        }
        const response = await postMdOnline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MD Withholding '}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('mdinformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}
export default MdInformationOnline
